import { render, staticRenderFns } from "./index copy.vue?vue&type=template&id=3b0f637a&scoped=true"
import script from "./index copy.vue?vue&type=script&lang=js"
export * from "./index copy.vue?vue&type=script&lang=js"
import style0 from "./index copy.vue?vue&type=style&index=0&id=3b0f637a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0f637a",
  null
  
)

export default component.exports